import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-modal" }
const _hoisted_2 = { class: "login-header" }
const _hoisted_3 = { class: "login-subtitle" }
const _hoisted_4 = { class: "login-form" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "form-group"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_11 = { class: "login-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "login-overlay",
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "login-title" }, "AIGC", -1)),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.mode === "login" ? "登录你的账号" : _ctx.mode === "register" ? "创建新账号" : "重置密码"), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[12] || (_cache[12] = _createElementVNode("label", null, "账号", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event)),
                  type: "text",
                  placeholder: "请输入账号",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.account]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "密码", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                  type: "password",
                  placeholder: _ctx.mode === 'reset' ? '请输入新密码' : '请输入密码',
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["enter"]))
                }, null, 40, _hoisted_7), [
                  [_vModelText, _ctx.password]
                ])
              ]),
              (_ctx.mode === 'reset')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", null, "验证码", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verifyCode) = $event)),
                      type: "text",
                      placeholder: "请输入验证码",
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.verifyCode]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "submit-btn",
                disabled: _ctx.loading,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
              }, _toDisplayString(_ctx.loading ? "处理中..." : _ctx.submitText), 9, _hoisted_9),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.mode === 'login')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mode = 'register'))
                    }, "没有账号？注册"),
                    _createElementVNode("a", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mode = 'reset'))
                    }, "忘记密码？")
                  ], 64))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mode = 'login'))
                  }, "已有账号？登录"))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}